// webVitals.js
'use strict';

/**
 * init web vitals
 * @param {object} options
 * @param {function} options.onReport
 */
export const initWebVitals = async ({ onReport } = {}) => {
  const { onCLS, onINP, onLCP, onFCP, onTTFB } = await import('web-vitals');

  onCLS(onReport);
  onINP(onReport);
  onLCP(onReport);
  onFCP(onReport);
  onTTFB(onReport);
};
